<template>
  <div><div id="cityMap" ref="cityMap" :style="{ width: '100%', height: '500px' }"></div></div>
</template>

<script>
import axios from 'axios'
var echartsMap
export default {
  name: 'Map',
  data () {
    return {
      provinces: ['shanghai', 'hebei', 'shanxi', 'neimenggu', 'liaoning', 'jilin', 'heilongjiang', 'jiangsu', 'zhejiang', 'anhui', 'fujian', 'jiangxi', 'shandong', 'henan', 'hubei', 'hunan', 'guangdong', 'guangxi', 'hainan', 'sichuan', 'guizhou', 'yunnan', 'xizang', 'shanxi1', 'gansu', 'qinghai', 'ningxia', 'xinjiang', 'beijing', 'tianjin', 'chongqing', 'xianggang', 'aomen', 'taiwan'],
      provincesText: ['上海', '河北', '山西', '内蒙古', '辽宁', '吉林', '黑龙江', '江苏', '浙江', '安徽', '福建', '江西', '山东', '河南', '湖北', '湖南', '广东', '广西', '海南', '四川', '贵州', '云南', '西藏', '陕西', '甘肃', '青海', '宁夏', '新疆', '北京', '天津', '重庆', '香港', '澳门', '台湾'],
      convertData: null
    }
  },
  mounted () {
    let selected = 'china'
    this.mapEcharts(selected)
  },
  methods: {
    mapEcharts (name) {
      var that = this
      var url = ''
      if (name === 'china') {
        url = '/static/json/' + name + '.json'
      } else {
        url = '/static/json/province/' + name + '.json'
      }

      echartsMap = that.$echarts.init(document.getElementById('cityMap'))

      // $.ajaxSettings.async = false
      axios.get(url).then(res => {
        console.log(res.data)
        var dataMap = res.data
        that.$echarts.registerMap(name, dataMap)
        // echartsMap.hideLoading()

        // var sanData = [
        //   // 散点数据 (value控制散点大小以及是否在省份地图显示)
        //   { name: '散点1', value: 1, url: 'https://www.baidu.com/', symbol: 'image://img/point.png', img: 'img/demo.jpg', areaname: 'hubei' },
        //   { name: '散点2', value: 1, url: 'https://www.baidu.com/', symbol: 'image://img/point.png', img: 'img/demo.jpg', areaname: 'sichuan' },
        //   { name: '散点3', value: 100, url: 'https://www.baidu.com/', symbol: 'image://img/point.png', img: 'img/demo.jpg', areaname: 'qinghai' },
        //   { name: '散点4', value: 1, url: 'https://www.baidu.com/', symbol: 'image://img/point.png', img: 'img/demo.jpg', areaname: 'guangxi' },
        //   { name: '散点5', value: 100, url: 'https://www.baidu.com/', symbol: 'image://img/point.png', img: 'img/demo.jpg', areaname: 'hebei' },
        //   { name: '散点6', value: 1, url: 'https://www.baidu.com/', symbol: 'image://img/point.png', img: 'img/demo.jpg', areaname: 'guangdong' }
        // ]

        var geoCoordMap = {
          // 散点坐标
          散点1: [113.52, 30.179],
          散点2: [103.42, 32.279],
          散点3: [98.32, 34.379],
          散点4: [108.22, 23.479],
          散点5: [118.12, 40.579],
          散点6: [113.62, 23.179]
        }
        var ceshi1 = [
          {value: [], areaname: 'xinjiang', name: '', symbol: 'image://static/img/point.png', size: 80}
        ]
        var ceshi = [
          {value: [86.61, 40.79], areaname: 'xinjiang', name: '', symbol: 'image://static/img/point.png', size: 80},
          {value: [89.13, 30.66], areaname: 'zizang', name: '', symbol: 'image://static/img/point.png', size: 80},
          {value: [128.34, 47.05], areaname: 'heilongjiang', name: '', symbol: 'image://static/img/point.png', size: 80},
          {value: [126.32, 43.38], areaname: 'jilin', name: '', symbol: 'image://static/img/point.png', size: 80},
          {value: [123.42, 41.29], areaname: 'liaoning', name: '', symbol: 'image://static/img/point.png', size: 80},
          {value: [112.17, 42.81], areaname: 'neimenggu', name: '', symbol: 'image://static/img/point.png', size: 80},
          {value: [116.40, 40.40], areaname: 'beijing', name: '', symbol: 'image://static/img/point.png', size: 80},
          {value: [106.27, 36.76], areaname: 'ningxia', name: '', symbol: 'image://static/img/point.png', size: 80},
          {value: [111.95, 37.65], areaname: 'shanxi', name: '', symbol: 'image://static/img/point.png', size: 80},
          {value: [115.21, 38.44], areaname: 'hebei', name: '', symbol: 'image://static/img/point.png', size: 80},
          {value: [117.04, 39.52], areaname: 'tianjin', name: '', symbol: 'image://static/img/point.png', size: 80},
          {value: [97.07, 35.62], areaname: 'qinghai', name: '', symbol: 'image://static/img/point.png', size: 80},
          {value: [103.82, 36.05], areaname: 'gansu', name: '', symbol: 'image://static/img/point.png', size: 80},
          {value: [118.01, 36.37], areaname: 'shandong', name: '', symbol: 'image://static/img/point.png', size: 80},
          {value: [108.94, 34.46], areaname: 'shanxi1', name: '', symbol: 'image://static/img/point.png', size: 80},
          {value: [113.46, 34.25], areaname: 'henan', name: '', symbol: 'image://static/img/point.png', size: 80},
          {value: [117.28, 31.86], areaname: 'anhui', name: '', symbol: 'image://static/img/point.png', size: 80},
          {value: [120.26, 32.54], areaname: 'jiangsu', name: '', symbol: 'image://static/img/point.png', size: 80},
          {value: [121.46, 31.28], areaname: 'shanghai', name: '', symbol: 'image://static/img/point.png', size: 80},
          {value: [103.36, 30.65], areaname: 'sichuan', name: '', symbol: 'image://static/img/point.png', size: 80},
          {value: [112.29, 30.98], areaname: 'hubei', name: '', symbol: 'image://static/img/point.png', size: 80},
          {value: [120.15, 29.28], areaname: 'zhejiang', name: '', symbol: 'image://static/img/point.png', size: 80},
          {value: [107.51, 29.63], areaname: 'chongqing', name: '', symbol: 'image://static/img/point.png', size: 80},
          {value: [112.08, 27.79], areaname: 'hunan', name: '', symbol: 'image://static/img/point.png', size: 80},
          {value: [115.89, 27.97], areaname: 'jiangxi', name: '', symbol: 'image://static/img/point.png', size: 80},
          {value: [106.91, 26.67], areaname: 'guizhou', name: '', symbol: 'image://static/img/point.png', size: 80},
          {value: [118.31, 26.07], areaname: 'fujian', name: '', symbol: 'image://static/img/point.png', size: 80},
          {value: [101.71, 24.84], areaname: 'yunnan', name: '', symbol: 'image://static/img/point.png', size: 80},
          {value: [121.01, 23.54], areaname: 'taiwan', name: '', symbol: 'image://static/img/point.png', size: 80},
          {value: [108.67, 23.68], areaname: 'guangxi', name: '', symbol: 'image://static/img/point.png', size: 80},
          {value: [113.98, 22.82], areaname: 'guangdong', name: '', symbol: 'image://static/img/point.png', size: 80},
          {value: [110.03, 19.33], areaname: 'hainan', name: '', symbol: 'image://static/img/point.png', size: 80},
          {value: [113.54, 22.19], areaname: 'aomen', name: '', symbol: 'image://static/img/point.png', size: 80},
          {value: [114.17, 22.32], areaname: 'xianggang', name: '', symbol: 'image://static/img/point.png', size: 80}
        ]

        this.convertData = function (data) {
          // 处理数据函数
          var res = []
          for (var i = 0; i < data.length; i++) {
            var geoCoord = geoCoordMap[data[i].name]
            var geoAreaname = data[i].areaname
            if (geoCoord && name === geoAreaname) {
              // 跳转到省级图标需放大
              res.push({
                name: data[i].name,
                value: geoCoord.concat(data[i].value * 101),
                url: data[i].url,
                symbol: data[i].symbol,
                img: data[i].img,
                areaname: data[i].areaname
              })
            }

            if (name === 'china') {
              // 在中国地图上图标显示同value
              res.push({
                name: data[i].name,
                value: geoCoord.concat(data[i].value),
                url: data[i].url,
                symbol: data[i].symbol,
                img: data[i].img,
                areaname: data[i].areaname
              })
            }
          }
          return res
        }

        var convertData2 = function (data) {
          // 处理数据函数
          var res = []
          if (name !== 'china') { data = ceshi1 }
          for (var i = 0; i < data.length; i++) {
            var geoCoord = data[i].value
            console.log(geoCoord)
            var geoAreaname = data[i].areaname

            if (geoCoord && name === geoAreaname) {
              // 跳转到省级图标需放大
              res.push({
                name: data[i].name,
                value: geoCoord.concat(data[i].size * 101),
                url: data[i].url,
                symbol: data[i].symbol,
                img: data[i].img,
                areaname: data[i].areaname
              })
            }

            if (name === 'china') {
              // 在中国地图上图标显示同value
              res.push({
                name: data[i].name,
                value: geoCoord.concat(data[i].size),
                url: data[i].url,
                symbol: data[i].symbol,
                img: data[i].img,
                areaname: data[i].areaname
              })
            }
          }
          return res
        }

        let option = {
          // tooltip: {
          //   trigger: 'item',
          //   show: false
          // },
          tooltip: {
            trigger: 'item',
            enterable: true, // 鼠标是否可进入提示框
            transitionDuration: 1, // 提示框移动动画过渡时间
            triggerOn: 'click', // 点击事件
            formatter: function (params) {
              console.log(params)
              if (params.name && params.value && params.data.value[2] > 100) {
                // params.data.value[2] > 100目的是为了在省级不弹窗
                var str =
                    '<a target="_blank" class="layui-btn layui-btn-normal layui-btn-sm pull-right" href="' +
                    params.data.url +
                    '"><img src=' +
                    params.data.img +
                    '/><p class="conut-next">' +
                    params.name +
                    '</p></a>'
                return str
              }
            },
            backgroundColor: '#fff',
            extraCssText: 'box-shadow: 0 3px 6px rgba(109, 130, 188,0.6);',
            padding: 10
          },
          geo: {
            // 地图配置
            show: true,
            map: name,
            label: {
              normal: {
                show: true
              },
              emphasis: {
                show: true
              }
            },
            roam: false, // 控制缩放
            itemStyle: {
              normal: {
                areaColor: '#6cf',
                shadowBlur: 1,
                shadowColor: '#0074BC',
                shadowOffsetX: 10,
                shadowOffsetY: 10
              },
              emphasis: {
                label: {
                  show: true // 选中状态是否显示省份名称
                },
                areaColor: '#fff',
                shadowOffsetX: 10,
                shadowOffsetY: 10,
                shadowBlur: 5,
                borderWidth: 10,
                shadowColor: 'rgba(0, 0, 0, 0.1)'
              }
            },
            regions: [
              {
                name: '南海诸岛',
                itemStyle: {
                  // 隐藏地图
                  normal: {
                    opacity: 0 // 为 0 时不绘制该图形
                  }
                },
                emphasis: {
                  opacity: 0
                },
                label: {
                  show: false // 隐藏文字
                }
              }
            ]

          },
          series: [
            {
              // 散点配置
              name: '数量',
              type: 'effectScatter',
              zlevel: 2,
              coordinateSystem: 'geo',
              symbolSize: function (val) {
                if (val[2] > 100) {
                  return [20, 27]
                } else {
                  return [0.2 * val[2], 0.27 * val[2]] // 两个参数对应宽高，点击进去省级后对应宽高乘以相应倍数
                }
              },
              symbolKeepAspect: true,
              showEffectOn: 'emphasis',
              rippleEffect: {
                brushType: 'stroke'
              },
              hoverAnimation: true,
              data: convertData2(ceshi)
            },
            {
              // 地图配置
              name: '地图',
              type: 'map',
              mapType: name, // 自定义扩展图表类型
              geoIndex: 1,

              textFixed: {
                Alaska: [20, -20]
              },

              label: {
                normal: {
                  show: true,
                  textStyle: {
                    color: '#fff'
                  }
                },
                emphasis: {
                  show: true,
                  textStyle: {
                    color: '#000'
                  }
                }
              },
              itemStyle: {
                normal: {
                  areaColor: '#0074BC', // '#4A9DE4',
                  borderColor: '#A2D9FC',
                  borderWidth: 1
                },
                emphasis: {
                  areaColor: '#fff',
                  shadowOffsetX: 10,
                  shadowOffsetY: 10,
                  shadowBlur: 5,
                  borderWidth: 2,
                  shadowColor: '#0074BC',
                  borderColor: 'rgba(0, 0, 0, 0)'
                }
              }
            }
          ]
        }

        echartsMap.setOption(option)

        // console.log(that.provincesText.length)

        echartsMap.getZr().on('click', (e) => {
          console.log('地图点击事件-能源类型-111---', typeof this.type,e)
          // this.commonRouter(this.transData)
          if (name !== 'china') { that.mapEcharts('china') }
        })

        echartsMap.on('click', function (param) {
          // console.log(param)
          // 遍历取到provincesText 中的下标  去拿到对应的省js
          event.stopPropagation()
          for (var i = 0; i < that.provincesText.length; i++) {
            // console.log(that.provinces[i])
            if (param.name === that.provincesText[i]) {
              // 显示对应省份的方法
              // showProvince(provinces[i]) ;
              // $('.close-back').show()
              that.mapEcharts(that.provinces[i])
              break
            }
          }
        })
      })
    }
  }
}
</script>

<style></style>
